import { dialogAlert, dialogOpen } from '../actions/creators/dialogs';
import * as actions from '../actions/types';
import CMX from '../api';

export const challengesMiddleware = ({ getState, dispatch }) => next => action => {
    next(action);

    switch (action.type) {
        case actions.USER_CHALLENGES_FETCH: return fetchUserChallenges(action, getState, dispatch);
        case actions.USER_CHALLENGE_ACTIVATE: return activateUserChallenge(action, getState, dispatch);
        case actions.USER_CHALLENGE_ACTIVATE_SUCCESS: return activateUserChallengeSuccess(action, getState, dispatch);
    }
};

function fetchUserChallenges(action, getState, dispatch) {
    CMX.get('/me/challenges/' + (action.payload.completed ? 'completed' : ''))
        .then(response => {
            dispatch({
                type: actions.USER_CHALLENGES_FETCH_SUCCESS,
                payload: response,
            });
        })
        .catch(error => {
            dispatch({
                type: actions.USER_CHALLENGES_FETCH_ERROR,
                payload: error,
            });
        });
}

function activateUserChallenge(action, getState, dispatch) {
    const { id } = action.payload;

    CMX.post(`/me/challenges/${id}/activate`)
        .then(response => {
            dispatch({
                type: ('activated' in response) && response.activated ? actions.USER_CHALLENGE_ACTIVATE_SUCCESS : actions.USER_CHALLENGE_ACTIVATE_ERROR,
                payload: { id },
            });
        })
        .catch(error => {
            dispatch({
                type: actions.USER_CHALLENGE_ACTIVATE_ERROR,
                payload: error,
            });
        }); 
}

function activateUserChallengeSuccess(action, getState, dispatch) {
    dispatch(dialogAlert({
        message: 'El reto ha sido activado con éxito.',
        icon: 'medal',
    }));
}